export const iconFontAwesomeTravelHotelBus = (
	<i className="fa-solid fa-bus"></i>
);
